import api from './client';
export interface LoginData { email: string; password: string; }
export interface RegisterData { company_name: string; currency_code: string; name: string; email: string; password: string; password_confirmation: string; timezone?: string; }
export interface AuthResponse { success: boolean; message: string; data: { token: string; user: { id: number; company_id: number; branch_id: number | null; role_id: number; name: string; email: string; scope: string; is_active: boolean; }; company_id: number; branch_id: number; }; }
export const authApi = {
  login: (data: LoginData) => api.post<AuthResponse>('/auth/login', data),
  register: (data: RegisterData) => api.post<AuthResponse>('/auth/register', data),
  me: () => api.get<{ success: boolean; data: AuthResponse['data']['user'] }>('/auth/me'),
  logout: () => api.post('/auth/logout'),
};
